import SubscriptionDetail from './SubscriptionDetail.vue';
import SubscriptionOverview from './detail/SubscriptionOverview.vue';
import SubscriptionJson from './detail/SubscriptionJson.vue';

export default function RemoteRoutes() {
  return [
    {
      path: ':id',
      component: SubscriptionDetail,
      children: [
        {
          path: 'overview',
          component: SubscriptionOverview,
          name: 'subscription2Overview'
        },
        {
          path: 'json',
          component: SubscriptionJson,
          name: 'subscription2Json'
        }
      ]
    }
  ]
}
